import Vue from 'vue'
import Router from 'vue-router'

import LoginView from './views/LoginView.vue'
import LoginCardComponent from '@/components/login/LoginCardComponent.vue';
import Factor2 from '@/components/login/Factor2.vue';
import ForgottenPassword from '@/components/login/ForgottenPassword.vue';

import UsersComponent from '@/components/app/users/UsersComponent.vue';
import AktasView from './views/app_views/AktasView.vue';
import FolderView from './views/app_views/FolderView.vue';
import FileUploadView from './views/app_views/FileUploadView.vue';
import InfosView from './views/app_views/InfosView.vue';
import ScrollView from './views/app_views/ScrollView.vue';
import SettingsView from '@/views/app_views/SettingsView.vue';
import AuthErrorView from '@/views/AuthErrorView.vue';

import TagsSettingsContainer from '@/components/app/settings_components/TagsSettingsContainer.vue';
import UserSettingsContainer from '@/components/app/settings_components/UserSettingsContainer.vue';

import NewInfoView from './views/app_views/NewInfoView.vue';
import NewAktaView from './views/app_views/NewAktaView.vue';
import { USER_LOGIN } from './store/action_types';
import store from '@/store/store.js';
import LocalStorage from '@/helpers/localstorage.js';

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: { name: 'login' },
    },
    {
      path: '/login',
      name: 'login',
      redirect: {name: 'main'},
      component: LoginView,
      children: [
        {
          path: 'main',
          name: 'main',
          component: LoginCardComponent
        },
        {
          path: 'sms',
          name: 'sms',
          component: Factor2
        }
        // {
        //   path: 'forgotten-password',
        //   name: 'forgotten-password',
        //   component: ForgottenPassword
        // }
      ]
    },
    {
      path: '/app',
      name: 'app',
      redirect: { name: 'infos'},
      component: () => import(/* webpackChunkName: "appView" */ './views/AppView.vue'),
      meta: {
        requiresLogin: true
      },
      children: [
        {
          path: 'users',
          name: 'users',
          component: UsersComponent
        },
        {
          path: 'aktas',
          name: 'aktas',
          component: AktasView,
          meta: {
            roles: ['ROLE_ADMIN', 'ROLE_ADVANCED_USER']
          }
        },
        {
          path: 'folders/:id',
          name: 'folder',
          component: FolderView,
        },
        {
          path: 'folders/:id/upload/:folderid',
          name: 'folder-file-upload',
          component: FileUploadView
        },
        {
          path: 'infos',
          name: 'infos',
          component: InfosView
        },
        // {
        //   path: 'file-upload/:id',
        //   name: 'file-upload',
        //   component: FileUploadView
        // },
        {
          path: 'new-info',
          name: 'new_info',
          component: NewInfoView
        },
        {
          path: 'new-akta',
          name: 'new_akta',
          component: NewAktaView,
          meta: {
            roles: ['ROLE_ADMIN', 'ROLE_ADVANCED_USER']
          }
        },
        {
          path: 'settings',
          name: 'settings',
          component: SettingsView,
          redirect: {
            name: 'tags-settings'
          },
          meta: {
            roles: ['ROLE_ADMIN']
          },
          children: [
            {
              path: 'tags',
              name: 'tags-settings',
              component: TagsSettingsContainer
            },
            {
              path: 'users',
              name: 'user-settings',
              component: UserSettingsContainer
            }
          ]
        }
        // {
        //   path: 'scroll',
        //   name: 'scroll',
        //   component: ScrollView
        // }
      ]
      
    },
    {
      path: '/error',
      name: 'auth-error',
      component: AuthErrorView,
      props: true
    }
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresLogin)) {
        if (!store.getters.getLoggedin) {
            const data = LocalStorage.getUserData();
            if (data) {
                store.dispatch({
                    type: USER_LOGIN,
                    ...data
                })
                next()
            } else {
                next({
                    name: 'login'
                })
            }
        } else {
            next()
        }
    } else {
        next();
    }
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.roles)) {
    let roleRequiredMatched = to.matched.filter(match => {
      if (match.meta.roles && match.meta.roles.length > 0) {
        return true;
      } else {
        return false;
      }
    })
    let i = 0;
    let roleConflict = false;
    while(i < roleRequiredMatched.length && !roleConflict) {
      if (roleRequiredMatched[i].meta.roles.some(role => store.getters.getRole(role))) {
        i += 1
      } else {
        roleConflict = true;
      }
    }
    if (roleConflict) {
      next({
        name: 'auth-error',
        params: {
            errorCode: 403
        }
      })
    } else {
      next();
    }
  } else {
    next();
  }
})

export default router;